const FormInput2 = (props) => {
    return (
        <div 
            className='flex items-center focus-within:border-accent focus-within:border-2 py-2.5 px-3 border border-neutral5 rounded mt-1.5 h-10'
            style={{ borderColor: props.error ? '#E85F5C' : null }}
        >
            <input 
                className='flex flex-1 focus:outline-none focus:border-0 gap-2.5 pe-2 self-stretch font-montserrat'
                id={props.id} 
                type={props.type}
                value={props.value}
                placeholder={props.placeholder}
                onChange={props.onChange}
                
            />
            
            <p className='font-montserrat text-neutral5'>{props.text}</p>
        </div>
    )
}

export default FormInput2